'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectGlsLocationFromCoordinates = selectGlsLocationFromCoordinates;

var _verify = require('helpers/verify');

var _bound = require('redux/saga/entities/bound');

function selectGlsLocationFromCoordinates(state, coordinates) {
  var _ref = coordinates || {},
      lat = _ref.lat,
      lon = _ref.lon;

  if ((0, _verify.isPresent)(lat) && (0, _verify.isPresent)(lon)) {
    return _bound.glsLocation.data(state, _bound.glsLocation.defaultKey(null, lat, lon));
  }
}